import { Injectable } from '@angular/core';

export class KjonnValg {
    Id: string;
    Text: string;
}

let kjonn: KjonnValg[] = [
    { Id:"IB", Text: "Kjønn ikke betydning" },
    { Id:"M", Text: "Mann" },
    { Id:"K", Text: "Kvinne" }
];

@Injectable()
export class Service {
    getkjonn(): KjonnValg[] {
        return kjonn;
    }
}


// WEBPACK FOOTER //
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/app/home/home.services.ts